var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicebarDropdownClosedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5343 6.539C11.6408 6.64553 11.8136 6.64553 11.9201 6.539C12.0266 6.43247 12.0266 6.25973 11.9201 6.1532L6.4657 0.698799C6.35916 0.592259 6.18643 0.592259 6.0799 0.698799L0.6255 6.1532C0.519 6.25973 0.519 6.43247 0.6255 6.539C0.731999 6.64553 0.9048 6.64553 1.0113 6.539L6.27528 1.27501L11.5343 6.539Z",
    fill: "black",
    stroke: "#09414E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicebarDropdownClosedArrow);
export default __webpack_public_path__ + "static/media/invoicebar-dropdown-closed-arrow.4fb40a4a88f374a70aec36b751fd7ec9.svg";
export { ForwardRef as ReactComponent };